import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { tblrows,getmessage,sendpostnow,getstacmessage } from './Dynamictable';
import Usersession from './Usersession';
import {showhidediv,hdactinf,insertpost} from './userdefaultdata';
import {actptnr} from './Uactingwithprtnr';

export default class Viewuserservices extends Component {

    constructor(props: any) {
   	super(props);
	this.state.name = "chat";
	
  	}
	
    state = {

	
        name: "world chat",
       respdata: null,   
       url: "",
       tblheaders:[''],		
       tblrows: [{id:1, nm: 'c',sts:0}],	
       serviceid:1,
       tblfiterdata: [{"sid":0,"sctid":0,"sr":0,nm:'',des:''}]
 	
    };

    
   
    
	
   
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
        debugger;
	
        const pid = localStorage.getItem("id");
        
        this.setserverurl();
        const ar = [{id:1, nm: 'c',sts:0},{id:2, nm: 'd',sts:0}]
	
	const cols = ["Activities"];
        this.setState({ tblheaders: cols });
	this.setState({ tblrows: ar});
        const sid = Usersession.getUserId();
        const tpid =1; 
        this.getpostdata(sid,tpid);

    }
 getpostdata(sid: any,tpid:any){
	 try {
          const url = "/getservienotify?sid=" + sid ;
	//alert(url);	
	axios.get(Configdata.srvurl + url)
            .then((response: any) => {
               
		const tdata = response.data;
               //alert(tdata);
                if(tdata != 'NA')
		this.reducearray(tdata);
              
            })
            .catch((err: any) => {
                getmessage('Something went wrong','');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

     reducearray(arr: any){
     let farr = [{}];

      if(arr){
       const objarr = arr[0];
        //  alert(JSON.stringify(objarr));
	     if(objarr.length > 0){
		for(let i =0;i< objarr.length;i++){
                
                 const rv = objarr[i];
		

		 farr.push(rv);
		 
		}
	    }
	 }
	if(farr.length > 2){
         farr.shift();
	// farr.shift();
         
	}
        
	//alert(JSON.stringify(farr));
	this.setState({ tblfiterdata: farr});
	
      }	
displayact(e:any,id:any,daid:any){
         const pdv = document.getElementById('chactwithptnr') as HTMLElement; 
         const dv = document.getElementById('Activityplay') as HTMLElement;
     dv.style.display = 'block';
   pdv.style.display = 'block';
   //  alert(id);
       const act = actptnr(id);
	ReactDOM.render(act,dv);

        const apiurl = "/deleteactivity";

    //const obj = {aid:daid};
   // insertpost(apiurl,obj);


}
displusrsrv(e:any,id:any,daid:any,mg:any){
        
getstacmessage(mg,'');

}

 deleteactivity(e:any){
   const codewithexp = e.target.id;
    const code = codewithexp.split(',')[0];
    const apiurl = "/deleteactivity";

    const obj = {aid:code};
    insertpost(apiurl,obj);
  // alert(code);
  
   
 }   
submitservice = (event:any) => {
         const stype = this.state.serviceid;
         const userid = Usersession.getUserId();
         const txtkeys = document.getElementById('servicekeysr') as HTMLInputElement;
          if(txtkeys){
		
		const utxt = txtkeys.value;
                const apiurl = '/addservicekeysts';
		txtkeys.value = '';
                const obj = {uid:userid,tpid:stype,txt:utxt};
               insertpost(apiurl,obj);
	}	
         showhidediv(true,'relavantkeyadds');
}
cancelservice = (event:any) => {
         showhidediv(true,'relavantkeyadds');
      
}
showservicekeyfield = (event:any,Id:any) => {
         showhidediv(false,'relavantkeyadds');
         
          try {
          const url = "/updateservienotify?sid=" + Id ;
	//alert(url);	
	axios.get(Configdata.srvurl + url)
            .then((response: any) => {
               
		const tdata = response.data;
               getmessage(tdata,'');
  
              
            })
            .catch((err: any) => {
                getmessage('Something went wrong','');
                
            });

                
          }
        catch (e) {
            debugger;

        }

      
}


 render() {

   
     return (

         <form>
	<div className="per100" id="lstact">
	 <div className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'45vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		
		<thead>
		   <tr>	
			
			<th className="comptd" style={{width:'80%'}}>Notifications</th>
			<th className="comptd" style={{width:'10%',backgroundColor:'blue',textAlign:'center'}}>X</th>
                        
			
		   </tr>	
		</thead>

		
		<tbody>
			{this.state.tblfiterdata.map((row,index)=>(
		<tr>
			<td className="comptd" style={{width:'80%'}}>
			  <a href="#" className="blanka" onClick={e => this.displusrsrv(e,row.sctid,row.sid,row.des)} >
				<span id={row.sid+","+'srv'}>{row.nm}</span>
			   </a>
			</td>
			<td className="comptd" style={{width:'10%',backgroundColor:'blue',textAlign:'center'}}>
			  <a href="#" className="blanka" onClick={e => this.showservicekeyfield(e,row.sid)} >
				<span id={row.sid+","+'srv'}>No use</span>
			   </a>
			</td>
		</tr>
			))}
		 </tbody>	
		
	   </table>
           <div id="relavantkeyadds" style={{width:'100%',display:'none',height:'auto'}}>

                 <div style={{width:'100%',height:'40px',position:'relative'}}>
                       	<div style={{width:'95%',height:'40px',backgroundColor:'transparent'}} className="setting-menu">
			 <span>
				
 <input type="text" placeholder="Enter relavant keys " style={{width:'99%',float:'left',marginTop:'1%',height:'30px'}} id="servicekeysr"  />
			 </span>
			</div>
                  </div>
    <div style={{width:'95%',height:'40px',position:'relative',marginTop:'10px'}}>

		     <a href="#" onClick={e=>this.submitservice(e)} title="Submit service">
                       	<div  className="setting-menu" style={{float:'right'}}>
			 <span style={{width:'auto'}}  className="deleteuserdv">
				 Submit 
			   </span>
			</div>
                      </a>
                     <a href="#" onClick={e=>this.cancelservice(e)} title="Submit service">
                       	<div className="setting-menu" style={{float:'right'}}>
			 <span style={{width:'auto'}} className="deleteuserdv">
				 Cancel 
			   </span>
			</div>
                      </a>
           </div>
        </div>

	 </div>		
	</div>
	
	</div>
   	</form>
    
   
      );
}
}

